import script from "./componentList.vue?vue&type=script&lang=js"
export * from "./componentList.vue?vue&type=script&lang=js"

import "./componentList.vue?vue&type=style&index=0&id=d8691d1a&lang=css"

const __exports__ = script;

export default __exports__